import React from 'react';
import { useField } from 'formik';
import InputMask from 'react-input-mask';
import { clsx } from 'clsx';

interface IMaskedInput {
  label: string;
  name: string;
  placeholder?: string,
  mask: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MaskedInput = ({
  label,
  placeholder,
  mask,
  ...props
}: IMaskedInput) => {
  const [field, meta] = useField(props);

  return (
    <div>
      {label && (
        <label htmlFor={field.name} className='text-sm text-slate-600'>{label}</label>
      )}

      <InputMask
        {...field}
        {...props}
        mask={mask}
        name={field.name}
        placeholder={placeholder}
        className={clsx(meta.touched && meta.error ? ' border-red-500' : 'border-slate-300', 'flex w-full h-10 border rounded-md px-4')}
      />

      {meta.touched && meta.error ? <p className='text-red-500 text-xs mt-1'>{meta.error}</p> : null}
    </div>
  );
};